import { useEffect } from "react";

export default function useSourceTracker() {
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const source = params.get("source");
        const campaign_id = params.get("ud"); // only for email campaign

        if (!source) return;

        console.log("Tracking Source:", source, "Email:", campaign_id);

        // Send to Google Analytics
        if (window.gtag) {
            window.gtag("event", "user_source_detected", {
                source: source,
                campaign_id: campaign_id || null,
                page: window.location.pathname,
                timestamp: Date.now(),
                debug_mode: true
            });
        }
    }, []);
}
